import React from "react";
import ThemeDefaultComponent from "../../components/ThemeDefaultComponent/ThemeDefaultComponent";
import LupaPasswordCard from "./components/LupaPasswordCard";
import useLupaPasswordForm from "./hooks/useLupaPasswordForm";

const LupaPassword = () => {
    const lupaPasswordForm = useLupaPasswordForm();

    return (
        <ThemeDefaultComponent>
            <LupaPasswordCard lupaPasswordForm={lupaPasswordForm} />
        </ThemeDefaultComponent>
    );
};

export default LupaPassword;
